import type { HelpFile } from '../../types/help'
import { ConnectorsTestIds } from '../../../testids/ConnectorsTestIds'

export const connectorsHelp: HelpFile = {
  texts: {
    [ConnectorsTestIds.connectorsWelcomeCard]:
      'Zentrale Anlaufstelle für eingehende und ausgehende Konnektoren — wählen Sie einen Unterbereich, um Datenimport- oder Provisionierungskonfigurationen zu verwalten.',
  },
}
